<template lang="html">
  <tr class="custom-display-element-access-row" :id="id">
    <td>{{ widget.name }}</td>
    <td>
      <div class="options">
        <toggle-button
          :id="`all-versions-${widget.uuid}`"
          :label="$t('allowAccess')"
          :on="allowAccess"
          @on-toggle-button-change="onToggleButtonChange"
        />
        <select-option-rich
          v-if="allowAccess"
          class="select-option"
          :id="`up-to-version-${widget.uuid}`"
          :label="$t('upToVersion')"
          :selected="selectedOption"
          :options="versions"
          @on-select-option-change="onSelectOptionChange"
        />
        <div class="loader" v-if="displayLoader"></div>
      </div>
    </td>
  </tr>
</template>

<script lang="js">
  import { MUTATION_NAME, TOAST_OPTIONS } from "@/static/global-variables";
  import distributionChannelUtil from "@/utils/distribution-channel-util";
  import DistributionChannelsService from "@/services/distributionChannelsService";
  import ToggleButton from "@/components/ToggleButton";
  import SelectOptionRich from "@/components/SelectOptionRich";

  export default  {
    name: "custom-display-element-access-row",
    components: {
      ToggleButton,
      SelectOptionRich
    },
    props: {
      id: String,
      uuid: String,
      customer: {
        type: Object,
        default: function() {
          return {}
        }
      },
      widget: {
        type: Object,
        default: function() {
          return {}
        }
      },
      widgetAccess: {
        type: Object,
        default: function() {
          return {}
        }
      },
      isFullAccess: Boolean
    },
    data () {
      return {
        allowAccess: false,
        displayLoader: false
      }
    },
    computed: {
      messages() {
        return this.$store.state.messages;
      },
      selectedOption() {
        let option = this.missingVersionNumber && this.versions? this.versions[0] : this.widgetAccess.version;
        if(option === distributionChannelUtil.prop.all || (this.allowAccess && this.widgetAccess.version === distributionChannelUtil.prop.none)) {
          option = distributionChannelUtil.prop.allLabel;
        }
        return option;
      },
      channelVersionList() {
        return this.channelVersions[this.uuid] || {};
      },
      channelVersions() {
        return this.$store.getters[MUTATION_NAME.CHANNEL_WIDGET_VERSION_LIST] || {};
      },
      versions() {
        return this.channelVersionList[this.widget.uuid]
      },
      selectedAccess() {
        return this.$store.getters[MUTATION_NAME.CUSTOMER_DOMAIN_WIDGET_ACCESS];
      },
      customerAccess() {
        return {...this.selectedAccess[this.customer.uuid] || {}};
      },
      missingVersionNumber() {
        return !this.widgetAccess.version;
      }
    },
    mounted() {
      if(this.widgetAccess.version === distributionChannelUtil.prop.all) {
        this.widgetAccess.version = distributionChannelUtil.prop.allLabel;
      }
      this.prevVersion = this.widgetAccess.version || distributionChannelUtil.prop.allLabel;
      let allowAccess;
      if (!this.isFullAccess && !this.widgetAccess.widgetId) {
        allowAccess = false;
        this.prevVersion = distributionChannelUtil.prop.none;
      } else {
        allowAccess = this.widgetAccess.version !== distributionChannelUtil.prop.none;
      }
      this.updateWidgetVersion(allowAccess);
    },
    methods: {
      isCurrentVersionIncluded() {
        const widgetsWithCurrentVersions = this.$store.getters.distributionChannelLatestWidgets.widgets;
        const wid = widgetsWithCurrentVersions.find(w => {
          return w.uuid === this.widget.uuid;
        });

        if (wid) {
          let ver = this.versions.find(v => {
            return v === wid.current.version;
          });
          return !!ver;
        }

        return false;
      },
      getVersions() {
        if(!this.versions || !this.isCurrentVersionIncluded()) {
          this.displayLoader = true;
          DistributionChannelsService.widgetVersionList(this.uuid, this.widget.uuid)
          .then(() => {
            if(this.missingVersionNumber) {
              this.widgetAccess.version = this.versions[0];
              this.updateWidgetAccess();
            }
          })
          .catch((e) => {
            this.$bvToast.toast(this.getMessageText(this.messages.ERROR_WHILE_LOADING), TOAST_OPTIONS.bottomCenter);
            console.error(e);
            this.updateWidgetVersion(!this.allowAccess);
          })
          .finally(() => {
            this.displayLoader = false;
          });
        }
      },
      onToggleButtonChange(allowAccess) {
        this.updateWidgetVersion(allowAccess);
      },
      updateWidgetVersion(allowAccess) {
        this.allowAccess = allowAccess;
        if(allowAccess) {
          this.widgetAccess.version = this.selectedOption;
        } else {
          this.widgetAccess.version = distributionChannelUtil.prop.none;
        }
        this.updateWidgetAccess();
        this.getVersions();
      },
      updateWidgetAccess() {
        const access = distributionChannelUtil.setupWidgetAccess(this.customerAccess, {
          customer: this.customer.uuid,
          uuid: this.widget.uuid,
          name: this.widget.name,
          version: this.widgetAccess.version,
          prevVersion: this.prevVersion,
          update: this.prevVersion !== this.widgetAccess.version
        });
        this.$store.commit(MUTATION_NAME.CUSTOMER_DOMAIN_WIDGET_ACCESS, access);
      },
      onSelectOptionChange(version) {
        this.widgetAccess.version = version;
        this.updateWidgetAccess();
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "@/styles/components/main";
  .custom-display-element-access-row {
    .options {
      display: flex;
      align-items: center;
      gap: 1.5rem;
      min-height: 2rem;
    }
    .loader {
      width: 1.3rem;
      height: 1.3rem;
      margin: 0;
    }
    .select-option {
      min-width: 12rem;
    }
  }
</style>
